export const sliderItems = [
    {
      id: 1,
      img: "https://i.ibb.co/XsdmR2c/1.png",
      title: "SUMMER SALE",
      desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
      bg: "f5fafd",
    },
    {
      id: 2,
      img: "https://i.ibb.co/DG69bQ4/2.png",
      title: "AUTUMN COLLECTION",
      desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
      bg: "fcf1ed",
    },
    {
      id: 3,
      img: "https://i.ibb.co/cXFnLLV/3.png",
      title: "LOUNGEWEAR LOVE",
      desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
      bg: "fbf0f4",
    },
  ];










  
  export const categories = [
    {
      id: 1,
      img: "https://shop.activeitzone.com/public/uploads/all/QFr6jOK360KnwVvONku4UnJzpIrY2M0314pWkXK9.png",
      title: "Women Clothing ...",
    },
    {
      id: 2,
      img: "https://shop.activeitzone.com/public/uploads/all/lMV8ZYzEzDA8QIaleuzcAr3zwVP2mVVOVcnOnRMD.png",
      title: "Men Clothing & Fa...",
    },
    {
      id: 3,
      img: "https://shop.activeitzone.com/public/uploads/all/0V78CrUJyi9nmr9SsqhK2AV8Rl0oTC44FUq45X8r.png",
      title: "Sports & Outdoor",
    },
    {
      id: 4,
      img: "https://shop.activeitzone.com/public/uploads/all/p7GDjaYAa9lLs32Zd1LqmXLze3ywrhOahKnNtNi6.png",
      title: "Automobile & Mot...",
    },
    {
      id: 5,
      img: "https://shop.activeitzone.com/public/uploads/all/kwYXmOKkm91XWRfGF8h8hVriGoPyOmhSmgi5InAJ.png",
      title: "Cellphones & Tabs",
    },
    {
      id: 6,
      img: "https://shop.activeitzone.com/public/uploads/all/uazXsowjuJ4ESShXDqGxf0SjlGQlyIwnm8yxNZEr.png",
      title: "Computer & Acce...",
    },
    {
      id: 7,
      img: "https://shop.activeitzone.com/public/uploads/all/A3KCAwbpJH7SjG6HQ3BhTXOhseT9LPnMhm92diga.png",
      title: "Beauty, Health &...",
    },
  ];

  export const popularProducts = [
    {
      id:1,
      img:"https://shop.activeitzone.com/public/uploads/all/kbKj4pi7j7a2v6YW0l2j4u3D6adKni2480oWNbqK.png",
      price: "$150",
      price1:"$140",
      category:"Electronics",
      Brand:"Nokia",
      title: "Nokia 6300 4G Dual sim | Wifi | Hotspot | Social",
      Desc:"lorem34",
    },
    {
      id:2,
      img:"https://shop.activeitzone.com/public/uploads/all/VlFKAwBynDPebbSce8FVsMPhfmu7sjSUapp3JIQw.png",
      price:"$350.00",
      price1:"$330.50",
      Brand:"Nokia",
      category:"Electronics",
      title:"Asus ROG phone 5 Dual sim s888 Phantom",
      Desc:"lorem34"
    },
    {
      id:3,
      img:"https://shop.activeitzone.com/public/uploads/all/KorbBNbxqdHYBKAbMvLH8W1OXdKnHIpd0jtI8wOh.png",
      price:"$303",
      price1:"$287.30",
      category:"Electronics",
      Brand:"Oneplus",
      title:"OnePlus 8 (Glacial Green 8GB RAM+128GB ROM",
      Desc:"Desc",
    },
    {
      id:4,
      img:"https://shop.activeitzone.com/public/uploads/all/XPIS3KaCLF1izpOyzROCjlv7tWEh3RmvAbNYlirl.png",
      price:"$204",
      price1:"$198.30",
      Brand:"Apple",
      title:"Apple Magic Keyboard with Touch Id for MAC",
      category:"Electronics",
      Desc:"Desc",
    },
    {
      id:5,
      img:"https://shop.activeitzone.com/public/uploads/all/brO9DLQukZXwzHMH9vExLST8L8w31nDk0ZqMxe3k.png",
      price:"$30",
      price1:"$29.10",
      Brand:"Apple",
      category:"Electronics",
      title:"Microsoft Surface ARC Mouse, CZV-000001",
      Desc:"Desc",
    },


    {
      id:6,
      img:"https://shop.activeitzone.com/public/uploads/all/kbKj4pi7j7a2v6YW0l2j4u3D6adKni2480oWNbqK.png",
      price: "$159",
      price1:"$140",
      Brand:"Nokia",
      category:"Electronics",
      title: "Nokia 6300 4G Dual sim | Wifi | Hotspot | Social",
      Desc:"lorem34",
    },

    //MENS

    {
      id:7,
      img:"https://shop.activeitzone.com/public/uploads/all/dCJrKJkUT3OHDIuXNYLyyKyNg84zGHued37VlrDW.png",
      price: "$65",
      price1:"$61.40",
      category:"Men",
      Brand:"Zara",
      title: "Peter England's men's slim fit Formal Shirt",
      Desc:"lorem34",
    },
    {
      id:8,
      img:"https://shop.activeitzone.com/public/uploads/all/o5rNBwXJJcv0QFLl2XD1T9UhTXLfFOlMAixnlGuG.png",
      price:"$158.00",
      price1:"$105.05",
      category:"Men",
      Brand:"Nike",
      title:"Nike sport's wear Storm-FIT Windrunner",
      Desc:"lorem34"
    },
    {
      id:9,
      img:"https://shop.activeitzone.com/public/uploads/all/SYfmNKm48ku1KPcojkPpgvaqxhJq5OEC9cg10kSz.webp",
      price:"$20",
      price1:"$19.20",
      Brand:"Zara",
      category:"Men",
      title:"Mens two piece suit Notched label sport Coat",
      Desc:"Desc",
    },
    {
      id:10,
      img:"https://shop.activeitzone.com/public/uploads/all/XM8e2es8RqQYpQbrXXReLAJpEHzyTdJdnuR2qup8.png",
      price:"$71.60",
      price1:"$69.85",
      Brand:"Zara",
      title:"Mens casual suit blazzer jackets lightweight",
      category:"Men",
      Desc:"Desc",
    },
    {
      id:11,
      img:"https://shop.activeitzone.com/public/uploads/all/zPD55J4qZlzeOOHVkQxiACSbTKYIUHPPxY99Ypy2.webp",
      price:"$275",
      price1:"$269",
      category:"Men",
      Brand:"Zara",
      title:"Marmot's men Stockholm Down puffee jacket",
      Desc:"Desc",
    },

    {
      id:12,
      img:"https://shop.activeitzone.com/public/uploads/all/BIGcFaDk6yUPbviuGaS3uXEfwbULatz5k9ois7Sh.webp",
      price: "$36",
      price1:"$34.25",
      category:"Men",
      Brand:"Nike",
      title: "Mens tundra winter jackets insulated water",
      Desc:"lorem34",
    },

    //Automobile

    {
      id:13,
      img:"https://shop.activeitzone.com/public/uploads/all/5ywHNpwAY6dNOapwWjUgLoeYsm18ZRwdU5PzXqJM.png",
      price: "$70",
      price1:"$68.30",
      category:"Automobile",
      Brand:"Honda",
      title: "Mobile 934768 20-W 50 Twin Synthetic oil",
      Desc:"lorem34",
    },
    {
      id:14,
      img:"https://shop.activeitzone.com/public/uploads/all/bkqIqtQXXZBYTTAHSAiBbVEeMGPaJfn0GeeF9EAy.png",
      price:"$120.80",
      price1:"$120",
      category:"Automobile",
      Brand:"Honda",
      title:"Mobile 1 Extended Performance full synthetic",
      Desc:"lorem34"
    },
    {
      id:15,
      img:"https://shop.activeitzone.com/public/uploads/all/YHRsyNhkszPAxcX3BxoWtvHkim3RPrfZXhAiOrLb.png",
      price:"$265",
      price1:"$239.20",
      category:"Automobile",
      Brand:"Honda",
      title:"Motorcycle full face helmet dot proved Ymh",
      Desc:"Desc",
    },
    {
      id:16,
      img:"https://shop.activeitzone.com/public/uploads/all/vwYSfoXPx86BXJVZ3mwKb7XyqFaQUKsj01QCnk7D.png",
      price:"$67.60",
      price1:"$61.85",
      Brand:"Hyundai",
      title:"Wheel LLC 20 inch Fits Doge Challenger",
      category:"Automobile",
      Desc:"Desc",
    },
    {
      id:17,
      img:"https://shop.activeitzone.com/public/uploads/all/VQyt8x49HM1Uxysbm367MrCLAv903JIpagGMnXB6.png",
      price:"$40",
      price1:"$38",
      category:"Automobile",
      Brand:"Hyundai",
      title:"12.5 inch golf Car steering Wheel Carbon",
      Desc:"Desc",
    },

    {
      id:18,
      img:"https://shop.activeitzone.com/public/uploads/all/v4LMuYrMj1Wsa42ScLawou8mB7YEPBx3o3r49MKk.png",
      price: "$57",
      price1:"$47.25",
      category:"Automobile",
      Brand:"Hyundai",
      title: "Key fob cover Fit for Huyndai Sonata Senata",
      Desc:"lorem34",
    },

    //Women
    {
      id:19,
      img:"https://shop.activeitzone.com/public/uploads/all/CtZC5bRWpgDGKdakd44TvCsJ4jwPfzl1GjS3Mz3N.png",
      price: "$81",
      price1:"$65.30",
      category:"Women",
      Brand:"Zara",
      title: "Women sleevless Lace pathwork deep V-Neck",
      Desc:"lorem34",
    },
    {
      id:20,
      img:"https://shop.activeitzone.com/public/uploads/all/ByeVzjm9wUbcwaeYeCPI6CQn6jhXjWEGuTs4079O.png",
      price:"$183.80",
      price1:"$147",
      category:"Women",
      Brand:"Zara",
      title:"Nike Air womens Velour Jaxcket Modern",
      Desc:"lorem34"
    },
    {
      id:21,
      img:"https://shop.activeitzone.com/public/uploads/all/2WwMTy7pGgdDCozZHJaWzj2fZwo13dsjobRgi5T4.png",
      price:"$66",
      price1:"$59.20",
      category:"Women",
      Brand:"Zara",
      title:"Womens sleevless chiffon Tiered Cocktail",
      Desc:"Desc",
    },
    {
      id:22,
      img:"https://shop.activeitzone.com/public/uploads/all/nWa9URNMbvsfzliuUuwZ7B4BlTAbTVvlhQwmACSQ.png",
      price:"$122.60",
      price1:"$97.85",
      Brand:"GulAhmed",
      title:"Women maxi Drak blue dress",
      category:"Women",
      Desc:"Desc",
    },
    {
      id:23,
      img:"https://shop.activeitzone.com/public/uploads/all/ix013yiczU4DZ4314gNCZTAljB2smAIRJV3ExsBC.png",
      price:"$139",
      price1:"$128",
      category:"Women",
      Brand:"GulAhmed",
      title:"night after Night Tonal Stripe short sleeve dress",
      Desc:"Desc",
    },

    {
      id:24,
      img:"https://shop.activeitzone.com/public/uploads/all/czQ4Vx7QS81vmzrklhw1kW7oM5Pz2SG9u22Qhsel.png",
      price: "$122",
      price1:"$104.25",
      category:"Women",
      Brand:"GulAhmed",
      title: "Fashions women Embellished shoulder",
      Desc:"lorem34",
    },

    //Beauty

    {
      id:25,
      img:"https://shop.activeitzone.com/public/uploads/all/F2qvMTTjzirGc5ngUP1aYPajl7zbBras8QJI2XN0.png",
      price: "$10",
      price1:"$9.30",
      category:"beauty",
      Brand:"Bold",
      title: "Addidas sport energy 3-in-1 bodywash",
      Desc:"lorem34",
    },
    {
      id:26,
      img:"https://shop.activeitzone.com/public/uploads/all/PqBt14kBFNlMKQQPgtvYVKs337vE0E2JHfZPZ5Qk.png",
      price:"$15.80",
      price1:"$14.07",
      category:"beauty",
      Brand:"Bold",
      title:"Oral peris 1.5% pure Acid serum oil",
      Desc:"lorem34"
    },
    {
      id:27,
      img:"https://shop.activeitzone.com/public/uploads/all/ZBzYj6F8lNg640OwzJ24yoXCeYa4n9YF6PkyW7bL.png",
      price:"$13",
      price1:"$12.20",
      category:"beauty",
      Brand:"Bold",
      title:"Olay reginest Micro Sculpting Cream",
      Desc:"Desc",
    },
    {
      id:28,
      img:"https://shop.activeitzone.com/public/uploads/all/v9YJM1JtmNY9YnVUOANin4t2zO4e8UtDTp7doRGj.webp",
      price:"$8",
      price1:"$7.85",
      title:"Vaselline petrolium jelly 7.5 Ounce",
      Barnd:"Nestle",
      category:"beauty",
      Desc:"Desc",
    },
    {
      id:29,
      img:"https://shop.activeitzone.com/public/uploads/all/VOfJEzj5M6T4x64HvdnGb1Sa8nsLVDfrpyaCinE6.webp",
      price:"$17",
      price1:"$8.90",
      category:"beauty",
      Brand:"Nestle",
      title:"Olay regenist Retinol 24 Night cream",
      Desc:"Desc",
    },

    {
      id:30,
      img:"https://shop.activeitzone.com/public/uploads/all/H5MMjYGNvyv0zfllqaj90xBKQdJDR8NKJ5S58uOP.png",
      price: "$19",
      price1:"$14.25",
      category:"beauty",
      Brand:"Nestle",
      title: "Olay age defying Advanced Gel Cream",
      Desc:"lorem34",
    },

    ];
    

  export const FlashSale = [
    {
      id:1,
      img:"https://shop.activeitzone.com/public/uploads/all/ix013yiczU4DZ4314gNCZTAljB2smAIRJV3ExsBC.png",
    },
    {
      id:2,
      img:"https://shop.activeitzone.com/public/uploads/all/zhD91QC7yQeUpuLDLiTug9bBporo0z9tyZv1hiHF.png",
    },
    {
      id:3,
      img:"https://shop.activeitzone.com/public/uploads/all/CBYD7muQopPffAO3De50AVnYbJwZl8zLKUEvxQeW.png",
    },
    {
      id:4,
      img:"https://shop.activeitzone.com/public/uploads/all/bKbaADHcAL5sQY2wDnALZ6Dk1vP37qXRmr3FP2rL.png",
    },
    {
      id:5,
      img:"https://shop.activeitzone.com/public/uploads/all/PqBt14kBFNlMKQQPgtvYVKs337vE0E2JHfZPZ5Qk.png",
    },
    {
      id:6,
      img:"https://shop.activeitzone.com/public/uploads/all/d5rlPozS5kSPgvrlpdNWuGMKQFBXZJFWKrKMcJzH.png",
    },
  ];


  export const Babys = [
    {
      id:1,
      img:"https://shop.activeitzone.com/public/uploads/all/e7GdN6JBEgtJCBW3zi8kWXTG2zzNOBjAJ3oLWJgG.png",
    },
    {
      id:2,
      img:"https://shop.activeitzone.com/public/uploads/all/6dyhZFGYmdA1rFQYqXc8Vdl2keeGzjjgmekQpgMQ.png",
    },
    {
      id:3,
      img:"https://shop.activeitzone.com/public/uploads/all/dA947yxDSJYVcJHHqGRB6X7q4Lst8IpTLEOIEbbd.png",
    },
    {
      id:4,
      img:"https://shop.activeitzone.com/public/uploads/all/62AcqeRysnyRhwXUqaCtqeXbWbIxOIgd71W5lPd5.png",
    },
    {
      id:5,
      img:"https://shop.activeitzone.com/public/uploads/all/DV6uO5T9wEG0pehfnzwvwhE7ayoMxOGpbYSecr8r.png",
    },
  ];

  export const Products1 = [
    {
      id:1,
      img:"https://shop.activeitzone.com/public/uploads/all/kbKj4pi7j7a2v6YW0l2j4u3D6adKni2480oWNbqK.png",
      price: "$150",
      price1:"$140",
      category:"Electronics",
      title: "Nokia 6300 4G Dual sim | Wifi | Hotspot | Social",
      Desc:"lorem34",
    },
    {
      id:2,
      img:"https://shop.activeitzone.com/public/uploads/all/VlFKAwBynDPebbSce8FVsMPhfmu7sjSUapp3JIQw.png",
      price:"$350.00",
      price1:"$330.50",
      category:"Electronics",
      title:"Asus ROG phone 5 Dual sim s888 Phantom",
      Desc:"lorem34"
    },
    {
      id:3,
      img:"https://shop.activeitzone.com/public/uploads/all/KorbBNbxqdHYBKAbMvLH8W1OXdKnHIpd0jtI8wOh.png",
      price:"$303",
      price1:"$287.30",
      category:"Electronics",
      title:"OnePlus 8 (Glacial Green 8GB RAM+128GB ROM",
      Desc:"Desc",
    },
    {
      id:4,
      img:"https://shop.activeitzone.com/public/uploads/all/XPIS3KaCLF1izpOyzROCjlv7tWEh3RmvAbNYlirl.png",
      price:"$204",
      price1:"$198.30",
      title:"Apple Magic Keyboard with Touch Id for MAC",
      category:"Electronics",
      Desc:"Desc",
    },
    {
      id:5,
      img:"https://shop.activeitzone.com/public/uploads/all/brO9DLQukZXwzHMH9vExLST8L8w31nDk0ZqMxe3k.png",
      price:"$30",
      price1:"$29.10",
      category:"Electronics",
      title:"Microsoft Surface ARC Mouse, CZV-000001",
      Desc:"Desc",
    },

    // {
    //   id:6,
    //   img:"https://shop.activeitzone.com/public/uploads/all/kbKj4pi7j7a2v6YW0l2j4u3D6adKni2480oWNbqK.png",
    //   price: "$150",
    //   price1:"$140",
    //   category:"Electronics",
    //   title: "Nokia 6300 4G Dual sim | Wifi | Hotspot | Social",
    //   Desc:"lorem34",
    // },
  ];
  
